import script from "./MysticsTab.vue?vue&type=script&setup=true&lang=js"
export * from "./MysticsTab.vue?vue&type=script&setup=true&lang=js"

import "./MysticsTab.vue?vue&type=style&index=0&id=08635ae0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-08635ae0"]])

export default __exports__